import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { QrCode, ArrowLeft, Search } from "lucide-react";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6" data-testid="not-found-page">
      <div className="text-center max-w-md animate-fade-in">
        <div className="w-20 h-20 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto mb-6">
          <Search size={36} className="text-primary" />
        </div>
        <h1 className="font-heading text-5xl font-extrabold mb-3 tracking-tight">404</h1>
        <h2 className="font-heading text-lg font-semibold mb-2">Page not found</h2>
        <p className="text-muted-foreground text-sm mb-8 leading-relaxed">
          The page you're looking for doesn't exist or has been moved. Let's get you back on track.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link to="/">
            <Button className="btn-glow gap-2" data-testid="not-found-home-btn">
              <ArrowLeft size={16} /> Back to Home
            </Button>
          </Link>
          <Link to="/login">
            <Button variant="outline" className="gap-2" data-testid="not-found-login-btn">
              <QrCode size={16} /> Log In
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
